import { Link } from "react-router-dom";
import { ArrowUpRight, Mail } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function CTABanner() {
  return (
    <section className="relative overflow-hidden bg-apx py-24 sm:py-28" data-testid="email-cta-banner">
      <div className="tech-grid absolute inset-0 opacity-[0.15]" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="font-mono text-xs font-bold uppercase tracking-[0.3em] text-ink/70">Start the conversation</p>
          <h2 className="mt-5 max-w-4xl font-display text-4xl font-black uppercase leading-none tracking-tight text-ink sm:text-6xl lg:text-7xl">
            One email. Zero uncertainty.
          </h2>
          <p className="mt-6 max-w-xl text-base font-medium leading-relaxed text-ink/80">
            Scope, schedule, or second opinion — send your project details and an APX specialist will respond with a plan, not a pitch.
          </p>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href="mailto:APX@apxproject.com?subject=Project%20Inquiry%20—%20APX%20Project%20Solutions"
              data-testid="cta-email-button"
              className="chamfer-sm group inline-flex items-center gap-3 bg-ink px-7 py-4 font-mono text-sm font-bold uppercase tracking-[0.15em] text-white transition-colors hover:bg-coal"
            >
              <Mail className="h-4 w-4 text-apx" />
              APX@apxproject.com
              <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
            <Link
              to="/contact"
              data-testid="cta-inquiry-form-link"
              className="chamfer-sm inline-flex items-center gap-2 border-2 border-ink px-7 py-4 font-mono text-sm font-bold uppercase tracking-[0.15em] text-ink transition-colors hover:bg-ink hover:text-white"
            >
              Project Inquiry Form
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
